<template>
  <div>
    <ul class="menu" :class="menuClass">
      <!-- 菜单 -->
      <!---->
      <li v-for="(item, index) in menuList" :key="index" class="menu-item">
        <!-- 路由跳转 -->
        <router-link
          v-if="item.route"
          :to="item.route"
          class="link"
          :class="{ active: currentRoute === item.route }"
          @click.native="closeDrawer"
        >
          {{ item.title }}
          <img v-if="item.icon" :src="item.icon" class="menu-icon" alt="icon" />
        </router-link>
        <!-- 外部系统跳转 -->
        <a v-else class="link" href="javascript:;" @click="goOuterSystem">{{
          item.title
          }}</a>
      </li>
    </ul>
    <mobile-dialog ref="mobileDialog"></mobile-dialog>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import { checkToken, uploadTransferBaseParam } from "@/libs/tools";
import MobileDialog from "@/components/MobileDialog";

export default {
  components: {
    "mobile-dialog": MobileDialog
  },
  data() {
    return {
      menuList: [
        {
          title: "首页",
          route: "/index",
          path: "/index"
        },
        {
          title: "在线询价",
          route: "/index#inquiry",
          icon: require("@/assets/img/icons/new.png")
        },
        {
          title: "保理融资"
        },
        {
          title: "关于我们",
          route: "/about"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getToken", "getAvatar", "getUsername", "isMobile"]),
    currentRoute() {
      return this.$route.fullPath;
    },
    menuClass() {
      return `menu__${this.isMobile ? "vertical" : "horizontal"}`;
    }
  },
  methods: {
    // 跳转到保理外部系统
    async goOuterSystem() {
      if (this.isMobile) {
        // this.$message.warning("移动端暂不支持");
       this.$refs.mobileDialog.show();
        return;
      }

      const token = await checkToken();
      if (token) {
        const url = await uploadTransferBaseParam(token);
        token && window.open(url, "_blank");
      }
    },

    closeDrawer() {
      this.isMobile && this.$emit("on-close");
    },
  }
};
</script>

<style lang="scss">
@import "./menu.scss";
</style>
